import z from 'zod';

export const insightHubCommentSummarySchema = z
  .object({
    summary: z
      .string()
      .describe('The summary of the comments. Has to be valid Markdown.'),
  })
  .describe('The schema for the summary data');

export const insightHubCommentAnalysisChartDataSchema = z.object({
  topics: z
    .array(
      z.object({
        name: z.string().describe('The topic/theme identified'),
        'Topic Weight Score': z.number().describe('Weighted importance score'),
      }),
    )
    .describe(
      'Array of topics with their weighted importance for the bar chart',
    ),
});

